import { getSessionActorId } from '#/utils/auth/sessionActor';

/**
 * FMS 異動 API（DELETE 除外）契約要求 `X-User-Id`＝登入者 UUID；缺少回 401。
 * @see backend-docs docs/api/fms/mutation-routes.md
 *
 * @param {object} [config] axios request config
 */
export function withFmsActor(config = {}) {
  const actorId = getSessionActorId();
  if (!actorId) {
    return config;
  }
  return {
    ...config,
    headers: {
      ...(config.headers || {}),
      'X-User-Id': actorId,
    },
  };
}
